<template>
  <label class="color-button d-block">
    <input
      name="color"
      :value="value"
      :disabled="disabled"
      :checked="isActiveColor(value)"
      @change="setColor"
      type="radio"
      class="color-button__input"
    />
    <span
      class="color-button__wrapper border-radius-md d-block"
      :class="{ active: isActiveColor(value) }"
    >
      <img class="img-cover" :src="src" :alt="name" />
    </span>
  </label>
</template>

<script>
export default {
  name: "ColorButton",
  props: {
    value: {
      type: Number,
    },
    name: {
      type: String,
      default: "colors",
    },
    color: {
      type: String,
      default: "white",
    },
    src: {
      type: String,
      default: "",
    },
  },
  inject: ["isActiveColor", "setColor"],
};
</script>

<style lang="scss">
@import "./color-button.scss";
</style>
